import Button from "@material-ui/core/Button";
import { Theme, withStyles } from "@material-ui/core";

const styles = (theme: Theme) => ({
    root: {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,

        padding: theme.spacing(5.625, 19, 5.625, 19),
        fontSize: "1rem",
        "&:hover": {
            backgroundColor: theme.palette.primary.dark
        },
        "&:disabled": {
            backgroundColor: "#bdbdbd",
            color: "#f5f5f5"
        }
    }
});

export default withStyles(styles)(Button);
